import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {ClientSidePermissionRoleLinkContainerModel} from '../../../../../models/aggregates/permissions';
import {Core2Config} from '../shared/core2Config';
import { ApiVisa, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
export class ClientSidePermissionRoleLinksAppletLoginService extends BaseApiTemplateService<ClientSidePermissionRoleLinkContainerModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
    + 'client-side-permission-role-links/applet-login-ep';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
        + 'client-side-permission-role-links/applet-login-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
        + 'client-side-permission-role-links/applet-login-ep';
        this.httpClient = http;
    }

    getByCriteriLoginEp(appletGuid: string, pagination: Pagination, apiVisa: ApiVisa) : Observable<PagingResponseModel<ClientSidePermissionRoleLinkContainerModel>>{
        if (apiVisa && apiVisa.api_domain_url != null){
            this.apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
            + 'client-side-permission-role-links/applet-login-ep';
        }
        const url = this.apiUrl + '/' + appletGuid + '/query?' + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<ClientSidePermissionRoleLinkContainerModel>>(
            url,
            this.getHttpHeader(apiVisa)
        );
    }
}